
// tslint:disable-next-line:no-any
export interface ILogTrackingInfo extends Record<string, any> {
  eventId?: string;
  date?: string;
  referenceId?: string;
  referenceUrl?: string;
}
